import styled from 'shared/utils/styled';

export const PmCompanyName = styled('span')(({ theme }) => ({
  fontSize: theme.typography.pxToRem(14),
  color: 'rgba(0, 0, 0, 0.87)',
}));
